import api from '../helpers/axios';

export interface ChangePasswordRequest {
  currentPassword: string;
  newPassword: string;
}

export interface ChangePasswordResponse {
  success: boolean;
  message: string;
}

/**
 * Service responsible for user profile self-service operations.
 * Follows the singleton pattern used across the frontend service layer.
 */
class UserProfileService {
  private static instance: UserProfileService;

  private constructor() {}

  static getInstance(): UserProfileService {
    if (!UserProfileService.instance) {
      UserProfileService.instance = new UserProfileService();
    }
    return UserProfileService.instance;
  }

  /**
   * Change the password of the currently authenticated user.
   * Verifies the current password on the server before applying the change.
   *
   * @param currentPassword - The user's existing password for verification
   * @param newPassword - The desired new password (min 8 characters)
   * @throws Error with a user-friendly message on failure
   */
  async changePassword(currentPassword: string, newPassword: string): Promise<void> {
    const payload: ChangePasswordRequest = { currentPassword, newPassword };
    const response = await api.post<ChangePasswordResponse>('/api/auth/change-password', payload);

    if (!response.data.success) {
      throw new Error(response.data.message || 'Failed to change password');
    }
  }
}

export default UserProfileService.getInstance();
